import OffSvg from '@/assets/images/off.svg'
import UserSvg from '@/assets/images/user.svg'
import IconButton from '@/components/UI/buttons/IconButton'
import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { logoutCurrentProfile } from '@/redux/reducers/auth/actions'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { FC } from 'react'
import { StyleSheet, Text, View } from 'react-native'

const CompactDrawerCurrentProfileCard: FC = () => {
    const profile = useAppSelector(authSelectors.currentProfile)

    const dispatch = useAppDispatch()

    if (!profile) {
        return null
    }

    const handlePress = () => {
        dispatch(logoutCurrentProfile())
    }

    return (
        <View style={styles.container}>
            <IconButton size={32} containerColor={ColorEnum.JET_100} Icon={UserSvg} />
            <View style={{ marginLeft: 8, gap: 4 }}>
                <Text style={styles.name}>{profile.name}</Text>
                <Text style={styles.description}>{profile.description}</Text>
            </View>
            <IconButton
                size={32}
                highlightContainerColor={ColorEnum.BRICK_600}
                Icon={OffSvg}
                onPress={handlePress}
                style={{ marginLeft: 'auto' }}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: ColorEnum.WHITE,
        borderRadius: 30,
        height: 46,
        width: 288,
        paddingLeft: 8,
        paddingRight: 10,
        marginTop: 24,
    },
    name: {
        color: ColorEnum.GRAY_900,
        fontFamily: FontEnum.SatoshiRegular,
        fontSize: 14,
    },
    description: {
        color: ColorEnum.GRAY_600,
        fontFamily: FontEnum.SatoshiRegular,
        fontSize: 12,
    },
})

export default CompactDrawerCurrentProfileCard
